import { createTheme } from '@material-ui/core/styles';

// assets
import colors from '../assets/scss/_themes-vars.module.scss';

// project imports
import { componentStyleOverrides } from './compStyleOverride';
import { themePalette } from './palette';
import { themeTypography } from './typography';

/**
 * Represent theme style and structure as per Material-UI
 * @param {JsonObject} customization customization parameter object
 */
export function theme(customization) {
    const color = colors;
    const isDark = customization.navType === 'dark';

    let themeOption = {
        colors: color,
        heading: isDark ? '#F1F5F9' : color.grey900,
        paper: isDark ? '#1E293B' : color.paper,
        backgroundDefault: isDark ? '#0F172A' : color.paper,
        background: isDark ? '#1E293B' : color.primaryLight,
        darkTextPrimary: isDark ? '#F1F5F9' : color.grey700,
        darkTextSecondary: isDark ? '#94A3B8' : color.grey500,
        textDark: isDark ? '#F1F5F9' : color.grey900,
        menuSelected: color.secondaryDark,
        menuSelectedBack: isDark ? '#334155' : color.secondaryLight,
        divider: isDark ? '#334155' : color.grey200,
        customization: customization
    };

    return createTheme({
        direction: 'ltr',
        palette: themePalette(themeOption),
        mixins: {
            toolbar: {
                minHeight: '48px',
                padding: '16px',
                '@media (min-width: 600px)': {
                    minHeight: '48px'
                }
            }
        },
        breakpoints: {
            values: {
                xs: 0,
                sm: 600,
                md: 960,
                lg: 1280,
                xl: 1920
            }
        },
        typography: themeTypography(themeOption),
        components: componentStyleOverrides(themeOption)
    });
}

export default theme;
